<app-recipes-translation-section
  [sectionOptions]="{
    title: 'RECIPE_TRANSLATION.SECTIONS.STEPS.HEADER',
    icon: 'ic_list',
    lang:
      stepsFields.length > 0
        ? {
            source: stepsInfos.source.lang,
            target: stepsInfos.target.lang
          }
        : undefined
  }"
>
  <div class="steps-container" *ngIf="stepsFields.length > 0; else noStep">
    <app-recipes-translation-fields-container
      *ngFor="let stepFields of stepsFields; index as i"
      [title]="
        ('RECIPE_TRANSLATION.SECTIONS.STEPS.TITLE' | translate) + ' ' + (i + 1) + ': ' + translatedStepType(stepsInfos.sourceSteps[i].type)
      "
    >
      <app-recipes-translation-fields-header *ngIf="getHeaderLabels(stepFields) | async as headerLabels" [labels]="headerLabels" />

      <ng-container *ngFor="let stepField of stepFields">
        <app-recipes-translation-variants [variants]="stepField.variants" />
        <app-recipes-translation-input-fields
          [fieldsOptions]="{
            size: 'sm',
            sourceControl: stepField.sourceControl,
            targetControl: stepField.targetControl,
            fieldName: {
              left: 'RECIPE_TRANSLATION.FIELDS_LABELS.DESCRIPTION' | translate,
              right: 'RECIPE_TRANSLATION.FIELDS_LABELS.SHORT_DESCRIPTION' | translate
            }
          }"
        />
      </ng-container>
    </app-recipes-translation-fields-container>
  </div>

  <ng-template #noStep>
    <p translate>RECIPE_TRANSLATION.SECTIONS.STEPS.NO_STEP</p>
  </ng-template>
</app-recipes-translation-section>
